import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TrainingSessionCompanyService {
    constructor(private http: HttpClient) {}

    delete(sessionId: number, companyId: number): Observable<any> {
        return this.http.delete<any>(
            '/api/training-sessions/' + sessionId + '/companies/' + companyId
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/session/company/training-session-company.service.ts